<div class="modal-content" [class.shadow-none]="false">
  <div class="modal-header align-items-start">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'familyMembership.title' | translate }}</h2>
    </div>
    <button type="button" class="btn btn-sm btn-icon btn-light" (click)="modal.dismiss()">
      <i class="ki-outline ki-cross fs-1"></i>
    </button>
  </div>
  <div class="modal-body">
    <!-- Current Family Members -->
    @if (existingMembers.length > 0) {
      <div class="mb-6">
        <label class="form-label fw-semibold">{{ 'familyMembership.currentMembers' | translate }}</label>
        <div class="border rounded">
          @for (member of existingMembers; track member.user.user_id) {
            <div class="d-flex align-items-center justify-content-between p-3" [class.border-bottom]="!$last">
              <div class="d-flex align-items-center">
                <div class="symbol symbol-40px me-3">
                  @if (member.user.profile_image_url) {
                    <img [src]="member.user.profile_image_url" alt="avatar" class="rounded-circle" style="width: 40px; height: 40px; object-fit: cover;">
                  } @else {
                    <div class="symbol-label bg-light-primary text-primary rounded-circle d-flex align-items-center justify-content-center fw-bold" style="width: 40px; height: 40px;">
                      {{ member.user.first_name?.charAt(0)?.toUpperCase() || '?' }}
                    </div>
                  }
                </div>
                <div>
                  <div class="fw-semibold text-gray-800">{{ member.user.first_name }} {{ member.user.last_name }}</div>
                  <div class="text-muted fs-7">{{ member.user.email }}</div>
                </div>
              </div>
              <div class="d-flex align-items-center gap-2">
                <span class="badge" [ngClass]="getRoleBadgeClass(member.role)">{{ getRoleLabel(member.role) }}</span>
                @if (canRemoveMember(member)) {
                  <button
                    type="button"
                    class="btn btn-sm btn-icon btn-light-danger"
                    [disabled]="isRemoving[member.user.user_id]"
                    (click)="removeMember(member)"
                    title="Remove member"
                  >
                    @if (isRemoving[member.user.user_id]) {
                      <span class="spinner-border spinner-border-sm"></span>
                    } @else {
                      <i class="ki-outline ki-trash fs-4"></i>
                    }
                  </button>
                }
              </div>
            </div>
          }
        </div>
      </div>
      <hr class="my-5">
      <label class="form-label fw-semibold mb-3">{{ 'familyMembership.addNewMember' | translate }}</label>
    }

    @if (!addChildAccount) {
      <div class="row spacing-30">
        <div class="col-12">
          <label class="form-label">{{ 'familyMembership.searchUser' | translate }}</label>
          <div class="position-relative">
            <div class="input-group">
              <span class="input-group-text">
                <i class="ki-outline ki-magnifier"></i>
              </span>
              <input
                type="text"
                class="form-control"
                [placeholder]="'familyMembership.searchPlaceholder' | translate"
                [value]="searchQuery"
                (input)="onSearchChange($any($event.target).value)"
              />
              @if (isSearching) {
                <span class="input-group-text">
                  <span class="spinner-border spinner-border-sm"></span>
                </span>
              }
            </div>

            <!-- Search Results Dropdown -->
            @if (searchResults.length > 0) {
              <div class="position-absolute w-100 mt-1 bg-white border rounded shadow-sm" style="z-index: 1000; max-height: 250px; overflow-y: auto;">
                @for (user of searchResults; track user.user_id) {
                  <div
                    class="d-flex align-items-center p-3 border-bottom cursor-pointer hover-bg-light"
                    (click)="selectUser(user)"
                    style="cursor: pointer;"
                  >
                    <div class="symbol symbol-40px me-3">
                      @if (user.profile_image_url) {
                        <img [src]="user.profile_image_url" alt="avatar" class="rounded-circle" style="width: 40px; height: 40px; object-fit: cover;">
                      } @else {
                        <div class="symbol-label bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                          {{ user.first_name?.charAt(0)?.toUpperCase() || '?' }}
                        </div>
                      }
                    </div>
                    <div>
                      <div class="fw-semibold text-gray-800">{{ user.first_name }} {{ user.last_name }}</div>
                      <div class="text-muted fs-7">{{ user.email }}</div>
                    </div>
                  </div>
                }
              </div>
            }

            <!-- No Results -->
            @if (searchQuery.length >= 2 && !isSearching && searchResults.length === 0 && !selectedUser) {
              <div class="text-muted mt-2 text-center py-3">
                <i class="ki-outline ki-user fs-2x text-gray-400 mb-2"></i>
                <div>{{ 'familyMembership.noUsersFound' | translate }}</div>
              </div>
            }
          </div>

          <!-- Selected User -->
          @if (selectedUser) {
            <div class="d-flex align-items-center justify-content-between p-3 mt-3 bg-light-primary border border-primary rounded">
              <div class="d-flex align-items-center">
                <div class="symbol symbol-40px me-3">
                  @if (selectedUser.profile_image_url) {
                    <img [src]="selectedUser.profile_image_url" alt="avatar" class="rounded-circle" style="width: 40px; height: 40px; object-fit: cover;">
                  } @else {
                    <div class="symbol-label bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                      {{ selectedUser.first_name?.charAt(0)?.toUpperCase() || '?' }}
                    </div>
                  }
                </div>
                <div>
                  <div class="fw-semibold text-gray-800">{{ selectedUser.first_name }} {{ selectedUser.last_name }}</div>
                  <div class="text-muted fs-7">{{ selectedUser.email }}</div>
                </div>
              </div>
              <button type="button" class="btn btn-sm btn-icon btn-light" (click)="clearSelection()">
                <i class="ki-outline ki-cross fs-3"></i>
              </button>
            </div>
          }
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 d-flex justify-content-between">
          <app-button
            [label]="'familyMembership.addChildWithoutAccount' | translate"
            [variant]="'outline'"
            (clicked)="addChildAccount = !addChildAccount"
          />
          <app-button
            [label]="'familyMembership.add' | translate"
            [variant]="'primary'"
            [disabled]="!selectedUser"
            (clicked)="addSelectedUser()"
          />
        </div>
      </div>
    }
    @if (addChildAccount) {
      <div class="row g-4 spacing-15">
        <div class="col-lg-6 col-12">
          <app-input-component
            [label]="'familyMembership.firstName' | translate"
            [placeholder]="'familyMembership.firstName' | translate"
            [type]="'text'"
            [(value)]="tempUser.firstName"
          />
        </div>
        <div class="col-lg-6 col-12">
          <app-input-component
            [label]="'familyMembership.lastName' | translate"
            [placeholder]="'familyMembership.lastName' | translate"
            [type]="'text'"
            [(value)]="tempUser.lastName"
          />
        </div>
      </div>
      <div class="row g-4 spacing-15">
        <div class="col-lg-6 col-6">
          <app-input-component
            [label]="'familyMembership.dateOfBirth' | translate"
            [placeholder]="'familyMembership.dateOfBirth' | translate"
            [type]="'date'"
            [(value)]="tempUser.date_of_birth"
          />
        </div>
        <div class="col-lg-6 col-6">
          <app-input-component
            [label]="'familyMembership.ridingClub' | translate"
            [placeholder]="'familyMembership.ridingClub' | translate"
            [type]="'text'"
            [(value)]="tempUser.riding_club"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <app-fileorini
            [accept]="'image/*'"
            (filesChanged)="tempUserProfileImage = $event[0]"
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col d-flex justify-content-end gap-3">
          <app-button
            [label]="'familyMembership.cancel' | translate"
            [variant]="'outline'"
            (clicked)="addChildAccount = false"
          />
          <app-button
            [label]="'familyMembership.addChild' | translate"
            [variant]="'primary'"
            (clicked)="addUserWithoutAccount()"
          />
        </div>
      </div>
    }
  </div>
</div>
